import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import { DevToolsView } from "./DevToolsView";

type Props = {
  viewTitle: ViewNameTranslation;
};

export function DevToolsPage({ viewTitle }: Props) {
  useNavbar({ viewTitle });
  return <DevToolsView />;
}
